module.exports = __webpack_public_path__ + "img/home-hero.db21afc4.jpg";